<template>
    <div class="mx-3">
        <payer-add-component></payer-add-component>

        <div class="row border-bottom mx-1">
            <div class="h2 col">Payers</div>
            <div v-if="clients.length > 1" class="col-4 ml-auto">
                <select v-bind:class="['custom-select', { 'text-primary' : clientId == 0 }]" v-model="clientId" @change="onChange($event)" required>
                    <option disabled value="0" hidden>Choose a client</option>
                    <option v-for="option in clients" :key="option.id" :value="option.id" v-text="option.name"></option>
                </select>        
            </div>          
            <div class="btn-toolbar mb-2" role="toolbar">
                <div class="btn-group">
                    <a :href="'/provider/clients/' + clientId + '/payercontracts'" class="btn btn-primary" title="View Payer Contracts"><i class="fa fa-file-contract fa-lg"></i></a>
                    <button class="btn btn-primary" title="Add Payer" @click="add()"><i class="fa fa-plus-circle fa-lg"></i></button>                    
                </div>
            </div>
        </div>
        <div class="row mt-3 mb-1">
            <div class="input-group col-md-4 ml-auto">
                <div class="input-group-prepend">
                    <div class="input-group-text"><i class="fas fa-search fa-lg text-muted"></i></div>
                </div>
                <input type="text" class="form-control" placeholder="Search" v-model="searchString">
            </div>                       
        </div>      
        <div v-if="payers.length" class="table-responsive">
            <table class="table table-striped table-sm">
                <thead>
                    <tr>
                        <th></th>
                        <th>Name</th> 
                        <th>Address</th>
                        <th>Phone</th>
                        <th>Fax</th>
                        <th class="text-right">Claims</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>       
                    <tr v-for="payer in filteredPayers" :key="payer.id">
                        <td class="fit"><i v-if="payer.contract_id" class="fas fa-file-contract fa-lg text-muted"></i></td>
                        <td>{{ payer.name }}</td>
                        <td>{{ address(payer) }}</td>
                        <td>{{ payer.phone_number | telephone }}</td>
                        <td>{{ payer.fax_number | telephone }}</td>
                        <td class="text-right">{{ payer.claim_count }}</td>
                        <td class="fit">
                            <div class="d-flex flex-row justify-content-end ml-4"> 
                                <a class="flex-fill pl-3" :href="'/provider/clients/' + clientId + '/payers/' + payer.id" title="Edit Payer"><i class="fas fa-edit fa-lg"></i></a>
                                <a v-if="payer.claim_count === 0" class="flex-fill pl-3" href="javascript:void(0)" @click="remove(payer.id)" title="Remove Payer from Client"><i class="fas fa-minus-circle fa-lg"></i></a>
                                <div v-else class="flex-fill pl-3"></div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-else class="pt-3 border-top">
            <h2 class="text-muted text-center">No active payers for this client.</h2>
        </div>       
    </div>    
</template>

<script>
import PayerAddComponent from './PayerAddComponent.vue';

export default {
    components: {
        PayerAddComponent,
    },
    props: {
        options: Array,
        selectedOptionId: Number
    },
    data() {
        return {
            clients: this.options,
            clientId: this.selectedOptionId,            
            payers: [],
            channel: null,
            channels: [],
            searchString: ''
        }
    },
    computed: {
        filteredPayers: function () {
            var self = this;
            return self.payers.filter(function (payer) {
                return (payer.name.toLowerCase().indexOf(self.searchString.toLowerCase()) !== -1);
            });
        },
    },    
    methods: {
        listen: function (value) {

            // leave the old channel
            if (this.channel) {
                window.Echo.leave(this.channel);
            }

            if (this.clientId) {

                // listen on the new channel and refresh the list if we get a payer event
                var self = this;
                this.channel = 'payer-event.' + this.clientId;
                window.Echo.private(this.channel).listen('PayerEvent', (e) => {
                    self.refresh();
                });
            }
            else {
                this.channel = null;
            }
        },
        refresh: function (listen) {
            axios.get('/ajax/provider/clients/' + this.clientId + '/payers')
                .then((response) => {

                    this.clients = response.data.clients;
                    this.payers = response.data.payers;

                    // if the selected client no longer exists in the dropdown choices set it to the first client
                    if (this.clients.length && this.clients.filter(e => e.id === this.clientId).length === 0) {
                        this.clientId = this.clients[0].id;
                        this.listen();
                    }
                    else if (listen) {
                        this.listen();
                    }
                })
                .catch((error) => {
                    toastr[error.response.data.level](
                        error.response.data.message, 
                        error.response.data.title, 
                        { timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true });
                });
        },
        onChange: function (e) {
            this.refresh(true);
        },
        add: function () {
            eventHub.$emit('show-payer-add', this.clientId);
        },
        remove: function (payerId) {
            axios.delete('/ajax/provider/clients/' + this.clientId + '/payers/' + payerId)
                .then(response => {
                    // nothing to do server will send payer event
                })
                .catch(error => {
                    toastr[error.response.data.level](
                        error.response.data.message, 
                        error.response.data.title, 
                        { timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true });
                });
        },
        address: function (payer) {
            return ((payer.address || '') + ' ' + (payer.city || '') + ' ' + (payer.state || '') + ' ' + (payer.postal_code || '')).trim();
        },
        search: function () {

        }       
    },
    created() {
        this.refresh(true);
    },
    beforeDestroy() {
        window.Echo.leave(this.channel);
    }   
}
</script>

<style scoped>

</style>


